/**
 * OnboardingPageCard — desktop two-column card layout for onboarding pages.
 *
 * On desktop (≥1200px): renders a centered wrapper with a cream/white
 * two-column card. The optional stepper renders inside the top of the
 * left column (above leftContent).
 * On mobile/tablet: renders nothing — children are rendered by the page itself.
 *
 * Props:
 *   stepper       ReactNode  — step counter dots (rendered at top of left column)
 *   leftContent   ReactNode  — title + subtitle (+ ToolTipLing at bottom)
 *   rightContent  ReactNode  — form / carousel + continue button
 *   leftWidth     number?    — optional explicit left column width in px (default: auto)
 */
import s from './OnboardingPageCard.module.css';

export default function OnboardingPageCard({ stepper, leftContent, rightContent, leftWidth }) {
  return (
    <div className={s.wrapper}>
      <div className={s.card}>
        <div
          className={s.leftCol}
          style={leftWidth ? { width: `${leftWidth}px` } : undefined}
        >
          {stepper && <div className={s.stepperWrap}>{stepper}</div>}
          {leftContent}
        </div>
        <div className={s.rightCol}>
          {rightContent}
        </div>
      </div>
    </div>
  );
}
